/**
 * @file コンポーネント：ローディング スタイル管理
 */

// ライブラリ読み込み
import styled, { keyframes } from "styled-components";

// アニメーション
const spinner = keyframes`
    from {
        transform: rotateZ(0);
    }

    to {
        transform: rotateZ(360deg);
    }
`;

// スタイル
export const StyledLoading = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
`;

export const StyledLoadingSpinner = styled.span`
    font-size: 187.5px;
    animation: 1s ease infinite ${spinner};
`;
